interface SectionHeadingProps {
  eyebrow: string;
  title: string;
  subtitle?: string;
  align?: 'left' | 'center';
  light?: boolean;
}

export default function SectionHeading({
  eyebrow,
  title,
  subtitle,
  align = 'center',
  light = false,
}: SectionHeadingProps) {
  const isCenter = align === 'center';

  return (
    <div className={`${isCenter ? 'text-center mx-auto max-w-2xl' : 'text-left max-w-2xl'}`}>
      <span
        className={`inline-flex items-center gap-2 text-xs tracking-[0.25em] font-label uppercase ${
          light ? 'text-accent-400' : 'text-primary-600'
        }`}
      >
        <span className={`h-px w-6 ${light ? 'bg-accent-400' : 'bg-primary-400'}`}></span>
        {eyebrow}
      </span>
      <h2
        className={`mt-4 font-heading font-semibold text-2xl md:text-4xl leading-snug ${
          light ? 'text-background-50' : 'text-foreground-950'
        }`}
      >
        {title}
      </h2>
      {subtitle && (
        <p className={`mt-4 text-sm md:text-base leading-relaxed ${light ? 'text-background-300' : 'text-foreground-600'}`}>
          {subtitle}
        </p>
      )}
    </div>
  );
}